import { useParams } from 'react-router-dom';

import { useNavigate, useSearchParams } from 'react-router-dom';
import apiCall from 'apps/investment/apiCalls/survey';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/AdminCRUD/page';
import ItemForm from './Form';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import QueryString from 'qs';

export const UserSurveyHistoryListPage = (props, { params }) => {
  let [filterParams, setSearchParams] = useSearchParams();
  let initialValues = QueryString.parse(filterParams.toString());

  const userID = initialValues?.user_id;
  return (
    <ListPage
      title="User Answers"
      apiCall={apiCall}
      params={params}
      columnGenerator={props => columnsGenerator(props)}
      resourceName="data"
      createUrl={`/investment/user-survey-histories/create?user_id=${userID}`}
      {...props}
    />
  );
};

export const UserSurveyHistoryEditPage = props => {
  const { id } = useParams();

  return (
    <EditPage
      title="User Answers"
      apiCall={apiCall}
      listUrl={`/investment/user-survey-histories/${id}`}
      ItemForm={ItemForm}
      options={{ title: 'Edit Answers' }}
      resourceName="data"
      {...props}
    />
  );
};

export const UserSurveyHistoryDetailPage = props => {
  return (
    <DetailPage
      title="User Answers"
      apiCall={apiCall}
      listUrl={`/investment/user-survey-histories`}
      ItemDetail={ItemDetail}
      resourceName="data"
      {...props}
    />
  );
};

export const UserSurveyHistoryCreatePage = props => (
  <CreatePage
    title="User Answers"
    apiCall={apiCall}
    listUrl={`/investment/user-survey-histories`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);
